// these wont be camelcase, because of index names in algolia
// DO NOT FORGET TO ADD TRANSLATION! These labels are translated in SortOptions.js
export default {
    products_sv_se: 'popular',
    products_sv_se_name_asc: 'name_asc',
    products_sv_se_name_desc: 'name_desc',
    products_sv_se_price_asc: 'price_asc',
    products_sv_se_price_desc: 'price_desc',
};
